<!--
 * @Author:
 * @Description: 数据质量评估设置弹框
-->
<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    title="数据质量维度/规则权重设置"
    @close="closeDialog"
    width="1200px"
    heigth="100%"
    v-dialogDrag
  >
    <el-row>
      <el-button type="primary" size="mini" @click="toAdd">新增</el-button>
      <el-button
        type="danger"
        size="mini"
        class="ml-10px"
        @click="toDelete(selections, selectedIndexs)"
        >删除</el-button
      >
    </el-row>
    <el-row class="flex-1 mt-20px h-420px">
      <el-table
        ref="table"
        v-loading="tableLoading"
        :data="tableData"
        height="100%"
        row-key="id"
        @selection-change="selectionChange"
        border
      >
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column label="数据质量维度" show-overflow-tooltip>
          <template slot-scope="scope">
            <!-- <span class="text-red-400 mr-5px">*</span> -->
            <el-select
              class="w-full"
              v-model="scope.row.qualityDimensionId"
              placeholder="请选择"
              :disabled="scope.row.disabled"
              filterable
              clearable
            >
              <el-option
                v-for="item in normativeList"
                :key="item.id"
                :label="item.displayName"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="维度权重" prop="dimensionWeight" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.dimensionWeight">{{ scope.row.dimensionWeight }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="质检规则" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-select
              class="w-full"
              v-model="scope.row.dataRuleTypeId"
              placeholder="请选择"
              :disabled="scope.row.disabled"
              filterable
              clearable
            >
              <el-option
                v-for="item in qualityList"
                :key="item.id"
                :label="item.displayName"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="规则权重" prop="weight" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.weight"
              class="w-100px"
              @input="weightChange(scope.row, $event)"
              placeholder="请输入"
              :disabled="scope.row.disabled"
              clearable
            ></el-input>
            %
          </template>
        </el-table-column>
        <el-table-column
          label="更新人"
          prop="lastModifiedUser"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="更新时间"
          prop="lastModifiedTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.disabled"
              type="primary"
              size="mini"
              @click="toEdit(scope.row)"
              >编辑</el-button
            >
            <el-button type="danger" size="mini" @click="toDelete([scope.row], [scope.$index])"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <div slot="footer" class="dialog-footer tc">
      <el-button type="primary" @click="toSave">保存</el-button>
      <el-button @click="closeDialog">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import dataRuleSettingService from '@/services/DataRuleSettingService'
import dataQualityAssessmentService from '@/services/DataQualityAssessmentService'

export default {
  name: 'qualityAssessmentSetting',
  props: {
    settingDialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      tableLoading: false,
      tableData: [],
      normativeList: [],
      qualityList: [],
      selections: [],
      selectedIndexs: [],
    }
  },
  watch: {
    settingDialogVisible: {
      immediate: true,
      async handler(val) {
        if (val) {
          // console.log(val, '弹框打开')
          this.dialogVisible = val
          await this.getList()
          this.getNormativeList()
          this.getQualityList()
          this.$refs.table.clearSelection()
        }
      },
    },
  },
  created() {},
  methods: {
    // 多选
    selectionChange(selection) {
      this.selections = selection
      this.selectedIndexs = this.selections.map((item) => {
        return this.tableData.indexOf(item)
      })
    },
    // 新增
    toAdd() {
      const newItem = {
        qualityDimensionId: '',
        dataRuleTypeId: '',
        weight: '',
        disabled: false,
        id: new Date().getTime().toString(), // 新增数据，id为时间戳
      }
      this.tableData.push(newItem)
      // this.$set(this.tableData, this.tableData.length, newItem)
    },
    // 编辑
    toEdit(row) {
      row.disabled = false
    },
    // 删除
    toDelete(selections, indexs) {
      if (!selections.length) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('确认要删除所选数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          if (indexs.length > 0) {
            for (let i = indexs.length - 1; i >= 0; i -= 1) {
              this.tableData.splice(indexs[i], 1)
            }
          }
          this.$refs.table.clearSelection()
        })
        .catch(() => {})
    },
    // 获取表格数据
    async getList() {
      this.tableLoading = true
      const res = await dataQualityAssessmentService.getDataQualityDimension()
      if (res && res.code === 0 && res.data && res.data.length > 0) {
        this.tableData = res.data.map((item) => {
          item.disabled = true
          return item
        })
      } else {
        this.tableData = []
      }
      this.tableLoading = false
    },
    // 保存
    async toSave() {
      const valid = this.isValid(this.tableData)
      // 校验通过
      if (valid) {
        const res = await dataQualityAssessmentService.addDataQualityDimension(this.tableData)
        if (res && res.code === 0) {
          this.$message.success('保存成功')
          this.closeDialog()
        }
      }
    },
    // 校验必填项
    checkRequiredFields(arr, key) {
      for (let i = 0; i < arr.length; i += 1) {
        if (!arr[i][key]) return false
      }
      return true
    },
    // 验证
    isValid(tableData) {
      let flag = false
      const qualityDimension = this.checkRequiredFields(tableData, 'qualityDimensionId')
      const dataRuleTypeId = this.checkRequiredFields(tableData, 'dataRuleTypeId')
      const weight = this.checkRequiredFields(tableData, 'weight')
      if (!qualityDimension) {
        this.$message.error('请选择数据质量维度')
        flag = false
      } else if (!dataRuleTypeId) {
        this.$message.error('请选择质检规则')
        flag = false
      } else if (!weight) {
        this.$message.error('请设置权重')
        flag = false
      } else {
        flag = true
      }
      return flag
    },
    // 权重只能输入数字
    weightChange(row, val) {
      row.weight = val.replace(/[^\d.]/g, '')
    },
    // 关闭弹框
    closeDialog() {
      this.dialogVisible = false
      this.$emit('closeDialog', false)
    },
    // 获取字典
    async getDimension(code) {
      const res = await dataRuleSettingService.getDic({
        code,
      })
      if (res && res.code === 0) {
        return _.head(res.data) || {}
      }
      return {}
    },
    // 获取维度下拉数据
    async getNormativeList() {
      const dic = await this.getDimension('QualityDimension')
      if (!_.isEmpty(dic)) {
        const res = await dataRuleSettingService.getRuleClass({
          skipCount: 0,
          maxResultCount: 999,
          dataCategoryId: dic.id,
        })
        if (res && res.code === 0) {
          this.normativeList = res.data
        }
      }
    },
    // 获取质检规则下拉数据
    async getQualityList() {
      const dic = await this.getDimension('DATARULETYPE')
      if (!_.isEmpty(dic)) {
        const res = await dataRuleSettingService.getRuleClass({
          skipCount: 0,
          maxResultCount: 999,
          dataCategoryId: dic.id,
        })
        if (res && res.code === 0) {
          this.qualityList = res.data
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
